
export default {
  inject: ['wordingPageProduct'],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      wordingPageProduct: this.wordingPageProduct,
    }
  },
  computed: {
    fittingGuideDescription() {
      switch (this.product?.fitting_guide) {
        case 'runs_small_size_up':
          return this.wordingPageProduct.fitting_guide_runs_small_size_up
        case 'between_small_true':
          return this.wordingPageProduct.fitting_guide_between_small_true
        case 'true_to_size':
          return this.wordingPageProduct.fitting_guide_true_to_size
        case 'between_large_true':
          return this.wordingPageProduct.fitting_guide_between_large_true
        case 'runs_large_size_down':
          return this.wordingPageProduct.fitting_guide_runs_large_size_down
        default:
          return null
      }
    },
  },
}
